import { styled } from '@mui/material/styles';
import { Card, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';

export const StyledCard = styled(Card)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
}));

export const StyledCardHeader = styled(CardHeader)({
  padding: '16px',
});

export const CardContentStyled = styled(CardContent)({
  height: '396px',
});
